"use client";

import React from "react";
import { usePathname } from "next/navigation";
import Aarti from "@/modules/Astro/Occult/Aarti";
import Chalisa from "@/modules/Astro/Occult/Chalisa";
import ChineseAstrology from "@/modules/Astro/Occult/ChineseAstrology";
import DharmaKarma from "@/modules/Astro/Occult/DharmaKarma";
import Mantra from "@/modules/Astro/Occult/Mantra";
import NadiAstrology from "@/modules/Astro/Occult/NadiAstrology";
import Numerology from "@/modules/Astro/Occult/Numerology";
import Nakshartra from "@/modules/Astro/Occult/Nakshatra";
import Palmistry from "@/modules/Astro/Occult/Palmistry";
import Psychic from "@/modules/Astro/Occult/Psychic";
import Swarodaya from "@/modules/Astro/Occult/Swarodaya";
import Vastu from "@/modules/Astro/Occult/Vastu";
import TarotReading from "@/modules/Astro/Occult/TarotReading";

const OccultPage = () => {
  const pathname = usePathname();
  const pathSegments = pathname.split("/").filter(Boolean);
  const subPage = pathSegments[pathSegments.length - 1];

  const renderModules = () => {
    if (!subPage || subPage.length === 0) {
      return <div>No modules to display. Please provide a valid path.</div>;
    } else if (subPage === "aarti") {
      return <Aarti />;
    } else if (subPage === "chalisa") {
      return <Chalisa />;
    } else if (subPage === "chinese-astrology") {
      return <ChineseAstrology />;
    } else if (subPage === "dharma-karma") {
      return <DharmaKarma />;
    } else if (subPage === "mantra") {
      return <Mantra />;
    } else if (subPage === "nadi-astrology") {
      return <NadiAstrology />;
    } else if (subPage === "numerology") {
      return <Numerology />;
    } else if (subPage === "nakshatra") {
      return <Nakshartra />;
    } else if (subPage === "palmistry") {
      return <Palmistry />;
    } else if (subPage === "psychic") {
      return <Psychic />;
    } else if (subPage === "swarodaya") {
      return <Swarodaya />;
    } else if (subPage === "vastu") {
      return <Vastu />;
    } else if (subPage === "tarot-reading") {
      return <TarotReading />;
    }
  };

  return <div>{renderModules()}</div>;
};

export default OccultPage;
